import React from 'react';
import { format } from 'date-fns-tz';
import { DNABox, DNAIcon, DNAText } from '@alucio/lux-ui';

interface ScheduleDocumentIconProps {
  scheduledPublish?: string,
  colorMode?: 'light' | 'dark'
}

export const ScheduleDocumentTooltip: React.FC<ScheduleDocumentIconProps> = (props) => {
  const { scheduledPublish, colorMode } = props
  const formattedDate = scheduledPublish ? format(new Date(scheduledPublish), "MMMM d, yyyy 'at' h:mm aa z") : '';

  const tooltipProps = colorMode === 'dark'
    ? { colorMode: 'dark' as const, color: 'white' }
    : { status: 'tertiary' as const };

  return (
    <DNABox spacing="xs" alignY="center">
      <DNAIcon.Styled name="clock" {...tooltipProps} />
      {scheduledPublish && (
        <DNAText numberOfLines={1} {...tooltipProps}>
          {`This file will be published on ${formattedDate}`}
        </DNAText>
      )}
    </DNABox>
  );
};

export default ScheduleDocumentTooltip;
